import styled from '@emotion/styled'

import { MiniIncomeGauge } from '../../../components'
import { formatPercentLabel } from '../../../utils'

const CUSTOM_EMPTY_LABEL = 'I’ll choose my own goal'

const MAX_CARD_WIDTH = 135
const MIN_CARD_HEIGHT = 172

// Reserve the selected border's space so the card doesn't resize.
const Card = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: ${MAX_CARD_WIDTH}px;
  min-height: ${MIN_CARD_HEIGHT}px;
  padding: 18px 12px 12px;
  border: 3px solid ${p => (p.$selected ? p.theme.primaryColor : 'transparent')};
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;

  &:hover:not(:disabled) {
    background: ${p => p.theme.cardHoverBgColor ?? '#f5fafc'};
  }
`

const Gauge = styled(MiniIncomeGauge)`
  margin-bottom: 8px;
`

const Title = styled.span`
  color: ${p => p.theme.darkestGray};
  font-size: 13px;
  font-weight: 600;
  text-align: center;
`

const Subtitle = styled.span`
  color: ${p => p.theme.mediumGray};
  font-size: 14px;
  font-weight: 400;
  line-height: 1.35;
  margin-top: 5px;
  text-align: center;
`

const IncomeReplacementOptionCard = ({
  title,
  percent,
  amount,
  selected,
  hasGoal = true,
  onSelect,
}) => (
  <Card type='button' $selected={selected} aria-pressed={selected} onClick={onSelect}>
    <Gauge percent={hasGoal ? percent : null} amount={hasGoal ? amount : null} />
    <Title>{title}</Title>
    <Subtitle>
      {hasGoal ? `${formatPercentLabel(percent)}% of current income` : CUSTOM_EMPTY_LABEL}
    </Subtitle>
  </Card>
)

export default IncomeReplacementOptionCard
